module.exports = __webpack_public_path__ + "media/dashboard/assets/images/external/whatsapp_inbox_gift-6db22d5ae9ad37b6c82eb876c1deb39d.png";